import { withProps } from 'recompose';

import Layout from 'app/components/layout/Layout';

const withLayout = component => withProps({ Component: component })(Layout);

export default withLayout;
